// HeaderStyle.js
export const classes = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 3, // Horizontal padding
    py: 2, // Vertical padding
    // borderBottom: '1px solid #ccc',
    backgroundColor: '#fff',
    maxWidth: '1200px', // Constrain width on large screens
    mx: 'auto', // Center horizontally
  },
  headerLeft: {
    // Additional styling if needed
  },
  brandLink: {
    fontWeight: 'bold',
    fontSize: '1.5rem',
    color: '#000',
    textDecoration: 'none',
    '&:hover': {
      color: '#007bff',
    },
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    // Use responsive gap values (MUI's spacing scale: 2*8=16px on mobile, 3*8=24px on desktop)
    gap: { xs: 2, md: 3 },
  },
  navLinksContainer: {
    display: { xs: 'none', md: 'flex' },
    alignItems: 'center',
    gap: 4,
  },
  navLink: {
    fontWeight: 500,
    textDecoration: 'none',
    color: '#000',
    cursor: 'pointer',
    '&:hover': {
      color: '#007bff',
    },
  },
};
